import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { AdminService } from '../../../../../../../services/admin/admin.service';
import { TdLoadingService } from '@covalent/core';

@Component({
  selector: 'app-send-for-discuss-dialog',
  templateUrl: './send-for-discuss-dialog.component.html',
  styleUrls: ['./send-for-discuss-dialog.component.scss']
})
export class SendForDiscussDialogComponent implements OnInit {
  supervisors = [];
  executors = [];

  selectedSupervisorId: number;
  selectedSupervisorComment: string;

  selectedExecutors: { id: number; comment?: string }[] = [];

  generalComment: string;

  constructor(
    public dialogRef: MatDialogRef<SendForDiscussDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _snackBar: MatSnackBar
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this._fetchMajorEmployees();
  }

  private _fetchMajorEmployees() {
    this._loadingService.register();
    this._adminService.getMajorEmployees().subscribe((employees) => {
      this._loadingService.resolve();
      employees.forEach((employee) => {
        if (employee.roles[0].role === 'PT.SUPERVISE.READ') {
          this.supervisors.push(employee);
        }
        if (employee.roles[0].role === 'PT.EXECUTE.READ') {
          this.executors.push(employee);
        }
      });
    },
    (err) => {
      this._loadingService.resolve()
      this._snackBar.open('დაფიქსირდა შეცდომა',null,{
        duration:2000,
        panelClass:'red-snackbar',
        horizontalPosition:"right",
        verticalPosition:"top"
      })
    });
  }

  resetSelectedSupervisorComment() {
    this.selectedSupervisorComment = null;
  }

  send() {
    if (this.selectedSupervisorId && this.generalComment) {
      this._loadingService.register();
      const reqData = {
        petitionId: this.data.id,
        commentary: this.generalComment,
        supervisorId: this.selectedSupervisorId,
        supervisorCommentary: this.selectedSupervisorComment,
        executors: this.selectedExecutors.map(function (e) {
          return { employeeId: e.id, commentary: e.comment };
        })
      };
      this._adminService.sendPetitionForDiscuss(reqData).subscribe((res) => {
        this._loadingService.resolve();
        this.dialogRef.close('პეტიციის სტატუსი წარმატებით შეიცვალა')
      },
      (err) => {
        this._loadingService.resolve()
        this._snackBar.open('დაფიქსირდა შეცდომა',null,{
          duration:2000,
          panelClass:'red-snackbar',
          horizontalPosition:"right",
          verticalPosition:"top"
        })
      });
    }
  }

  existsInSelectedExecutors(executor): boolean {
    return (
      this.selectedExecutors.findIndex((item) => item.id === executor.id) > -1
    );
  }

  onSelectedExecutorCommentChange(event, executor) {
    const typedText = event.srcElement.value;
    const executorIndex = this.selectedExecutors.findIndex(
      (item) => item.id === executor.id
    );
    if (executorIndex > -1) {
      this.selectedExecutors[executorIndex].comment = typedText;
    }
  }

  onExecutorCheckboxChange(e, selectedExecutor) {
    if (e.checked) {
      this.selectedExecutors.push({
        id: selectedExecutor.id,
        comment: ''
      });
    } else {
      const removableExecutorIndex = this.selectedExecutors.findIndex(
        (executor) => executor.id === selectedExecutor.id
      );
      if (removableExecutorIndex > -1) {
        this.selectedExecutors.splice(removableExecutorIndex, 1);
      }
    }
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/send-for-discuss-dialog/send-for-discuss-dialog.component.ts